import RestService from "../services/rest.service"

export const getCalibrationList = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/calibration`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getCalibrationDetail = (serial, version = null) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let url = `app/kpi/calibration/${serial}`
    if (version) url += '?version=' + version
    RestService.get(url).then(
      (response) => {
        let data = response.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getEmployeeCalibrationDetail = (calibration, employee) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/calibration/${calibration}/item/${employee}`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postSaveCalibration = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/calibration/save`, data).then(
      () => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postSubmitCalibration = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/workflow/calibration/submit`, data).then(
      () => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postWorkflowSubmit = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/workflow/calibration/submit`, data).then(
      () => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const postWorkflowReject = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.post(`app/kpi/workflow/calibration/reject`, data).then(
      () => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const downloadCalibrationData = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/calibration/download/` + id).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}